
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const LiveStreamingPage = () => {
  const [selectedStream, setSelectedStream] = useState('main');

  const liveStreams = [
    {
      id: 'main',
      title: 'PAAM Main Service',
      status: 'live',
      viewers: '2,847',
      description: 'Join us for our main weekly service with apostolic teaching and worship',
      streamUrl: 'https://www.youtube.com/embed/live_stream?channel=PAAM_MAIN',
      schedule: 'Sundays 10:00 AM WAT'
    },
    {
      id: 'cfn',
      title: 'CFN Global Fellowship',
      status: 'upcoming',
      viewers: '0',
      description: 'Christ Family Network global fellowship and prayer meeting',
      streamUrl: 'https://www.youtube.com/embed/live_stream?channel=CFN_GLOBAL',
      schedule: 'Wednesdays 7:00 PM WAT'
    },
    {
      id: 'prayer',
      title: 'Morning Prayer Session',
      status: 'offline',
      viewers: '0',
      description: 'Daily morning prayer and intercession with the PAAM family',
      streamUrl: 'https://www.youtube.com/embed/live_stream?channel=PAAM_PRAYER',
      schedule: 'Daily 6:00 AM WAT'
    }
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'All Believers International Convention (ABIC) 2025',
      date: 'Deember 15-18, 2025',
      time: '9:00 AM - 6:00 PM Daily',
      description: 'Four days of apostolic teaching, worship, and fellowship streamed live',
      image: 'https://readdy.ai/api/search-image?query=live%20streaming%20setup%20for%20christian%20convention%2C%20professional%20broadcast%20equipment%2C%20large%20auditorium%20with%20cameras%2C%20modern%20ministry%20streaming%20technology&width=400&height=300&seq=abicstream&orientation=landscape'
    },
    {
      id: 2,
      title: 'Christ Gospel Crusade - Ghana',
      date: 'January 20-22, 2025',
      time: '6:00 PM - 9:00 PM',
      description: 'Massive evangelistic crusade with signs, wonders, and miracles',
      image: 'https://readdy.ai/api/search-image?query=outdoor%20crusade%20live%20streaming%2C%20large%20crowd%20at%20evening%20gospel%20event%2C%20professional%20video%20production%20for%20ministry%20broadcast%2C%20evangelistic%20gathering&width=400&height=300&seq=ghanastream&orientation=landscape'
    },
    {
      id: 3,
      title: 'CFN Leadership Summit',
      date: 'February 10-12, 2025',
      time: '10:00 AM - 4:00 PM',
      description: 'Intensive leadership training for CFN coordinators worldwide',
      image: 'https://readdy.ai/api/search-image?query=virtual%20conference%20streaming%20setup%2C%20leadership%20training%20broadcast%2C%20professional%20ministry%20webinar%2C%20online%20christian%20education%20platform&width=400&height=300&seq=cfnstream&orientation=landscape'
    }
  ];

  const platforms = [
    {
      name: 'YouTube',
      icon: 'ri-youtube-fill',
      url: 'https://youtube.com/@PAAMMinistry',
      subscribers: '45.2K',
      color: 'text-red-600'
    },
    {
      name: 'Facebook',
      icon: 'ri-facebook-fill',
      url: 'https://facebook.com/PAAMMinistry',
      followers: '32.8K',
      color: 'text-blue-600'
    },
    {
      name: 'Instagram',
      icon: 'ri-instagram-fill',
      url: 'https://instagram.com/paamministry',
      followers: '18.5K',
      color: 'text-pink-600'
    },
    {
      name: 'Website',
      icon: 'ri-global-line',
      url: 'https://portal.paamintl.org/live',
      followers: 'Live Portal',
      color: 'text-[#b8144a]'
    }
  ];

  const currentStream = liveStreams.find(stream => stream.id === selectedStream);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="absolute inset-0 bg-black/50"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20church%20live%20streaming%20setup%20with%20professional%20cameras%20and%20lighting%2C%20ministry%20broadcast%20technology%2C%20contemporary%20worship%20service%20being%20filmed%2C%20high-tech%20ministry%20production&width=1200&height=600&seq=livestreamhero&orientation=landscape')`
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Live Streaming
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Join thousands of believers worldwide for live worship, apostolic teaching, and fellowship from anywhere in the world
          </p>
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="flex items-center">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse mr-2"></div>
              <span className="text-lg font-semibold">LIVE NOW</span>
            </div>
            <div className="text-lg">
              <i className="ri-eye-line mr-2"></i>
              2,847 viewers
            </div>
          </div>
          <a 
            href="#live-stream" 
            className="bg-[#b8144a] hover:bg-[#9a1139] text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap"
          >
            Watch Live Now
          </a>
        </div>
      </section>

      {/* Live Stream Player */}
      <section id="live-stream" className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Main Stream */}
            <div className="lg:col-span-2">
              <div className="bg-black rounded-xl overflow-hidden shadow-2xl">
                <div className="aspect-video bg-gray-900 flex items-center justify-center">
                  {currentStream?.status === 'live' ? (
                    <div className="text-center text-white">
                      <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-live-line text-2xl"></i>
                      </div>
                      <h3 className="text-xl font-bold mb-2">{currentStream.title}</h3>
                      <p className="text-gray-300 mb-4">{currentStream.description}</p>
                      <div className="flex items-center justify-center gap-4 text-sm">
                        <div className="flex items-center">
                          <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse mr-2"></div>
                          LIVE
                        </div>
                        <div className="flex items-center">
                          <i className="ri-eye-line mr-1"></i>
                          {currentStream.viewers} viewers
                        </div>
                      </div>
                    </div>
                  ) : currentStream?.status === 'upcoming' ? (
                    <div className="text-center text-white">
                      <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-calendar-line text-2xl"></i>
                      </div>
                      <h3 className="text-xl font-bold mb-2">{currentStream.title}</h3>
                      <p className="text-gray-300 mb-4">{currentStream.description}</p>
                      <p className="text-blue-400 font-semibold">{currentStream.schedule}</p>
                    </div>
                  ) : (
                    <div className="text-center text-white">
                      <div className="w-16 h-16 bg-gray-600 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-pause-circle-line text-2xl"></i>
                      </div>
                      <h3 className="text-xl font-bold mb-2">Stream Offline</h3>
                      <p className="text-gray-300 mb-4">Check back during scheduled service times</p>
                      <p className="text-gray-400">{currentStream?.schedule}</p>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Stream Info */}
              <div className="mt-6 bg-white rounded-xl shadow-lg p-6">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">{currentStream?.title}</h2>
                <p className="text-gray-600 mb-4">{currentStream?.description}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="flex items-center text-sm text-gray-500">
                      <i className="ri-calendar-line mr-2"></i>
                      {currentStream?.schedule}
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <i className="ri-eye-line mr-2"></i>
                      {currentStream?.viewers} watching
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button className="p-2 text-gray-600 hover:text-[#b8144a] transition-colors">
                      <i className="ri-share-line text-xl"></i>
                    </button>
                    <button className="p-2 text-gray-600 hover:text-[#b8144a] transition-colors">
                      <i className="ri-heart-line text-xl"></i>
                    </button>
                    <button className="p-2 text-gray-600 hover:text-[#b8144a] transition-colors">
                      <i className="ri-notification-3-line text-xl"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              {/* Stream Selection */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Available Streams</h3>
                <div className="space-y-3">
                  {liveStreams.map((stream) => (
                    <button
                      key={stream.id}
                      onClick={() => setSelectedStream(stream.id)}
                      className={`w-full text-left p-3 rounded-lg transition-colors ${
                        selectedStream === stream.id
                          ? 'bg-[#b8144a] text-white'
                          : 'bg-gray-50 hover:bg-gray-100 text-gray-900'
                      }`}
                    >
                      <div className="flex items-center justify-between mb-1">
                        <span className="font-semibold">{stream.title}</span>
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          stream.status === 'live' ? 'bg-red-100 text-red-800' :
                          stream.status === 'upcoming' ? 'bg-blue-100 text-blue-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {stream.status}
                        </span>
                      </div>
                      <p className={`text-sm ${
                        selectedStream === stream.id ? 'text-white/80' : 'text-gray-600'
                      }`}>
                        {stream.schedule}
                      </p>
                    </button>
                  ))}
                </div>
              </div>

              {/* Watch on Platforms */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Watch on Other Platforms</h3>
                <div className="space-y-3">
                  {platforms.map((platform) => (
                    <a
                      key={platform.name}
                      href={platform.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                      <div className="flex items-center">
                        <i className={`${platform.icon} text-2xl ${platform.color} mr-3`}></i>
                        <div>
                          <div className="font-semibold text-gray-900">{platform.name}</div>
                          <div className="text-sm text-gray-600">{platform.followers}</div>
                        </div>
                      </div>
                      <i className="ri-external-link-line text-gray-400"></i>
                    </a>
                  ))}
                </div>
              </div>

              {/* Quick Links */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Quick Links</h3>
                <div className="space-y-2">
                  <a href="/events" className="block text-[#b8144a] hover:underline">
                    <i className="ri-calendar-line mr-2"></i>
                    Upcoming Events
                  </a>
                  <a href="/resources" className="block text-[#b8144a] hover:underline">
                    <i className="ri-download-line mr-2"></i>
                    Download Resources
                  </a>
                  <a href="/join" className="block text-[#b8144a] hover:underline">
                    <i className="ri-user-add-line mr-2"></i>
                    Join PAAM Family
                  </a>
                  <a href="https://portal.paamintl.org/" className="block text-[#b8144a] hover:underline">
                    <i className="ri-hand-heart-line mr-2"></i>
                    Prayer Requests
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Upcoming Live Events */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Upcoming Live Events</h2>
            <p className="text-xl text-gray-600">Don't miss these special broadcasts</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {upcomingEvents.map((event) => (
              <div key={event.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={event.image} 
                  alt={event.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{event.title}</h3>
                  <p className="text-gray-600 mb-4">{event.description}</p>
                  
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center text-sm text-gray-700">
                      <i className="ri-calendar-line w-4 h-4 flex items-center justify-center mr-2 text-[#b8144a]"></i>
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-700">
                      <i className="ri-time-line w-4 h-4 flex items-center justify-center mr-2 text-[#b8144a]"></i>
                      <span>{event.time}</span>
                    </div>
                  </div>
                  
                  <button className="w-full bg-[#b8144a] hover:bg-[#9a1139] text-white py-2 px-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
                    <a href="/join" className="text-white">Set Reminder - Join CFN</a>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Live Streaming Features */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Watch Live?</h2>
            <p className="text-xl text-gray-600">Experience the power of live fellowship and apostolic teaching</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-live-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Real-Time Fellowship</h3>
              <p className="text-gray-600">Join thousands of believers worldwide in live worship and prayer.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-message-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Interactive Chat</h3>
              <p className="text-gray-600">Participate in live discussions and receive prayer during services.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-notification-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Instant Notifications</h3>
              <p className="text-gray-600">Get notified when special events and services go live.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-device-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Multi-Platform Access</h3>
              <p className="text-gray-600">Watch on any device through our website or mobile apps.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-[#b8144a] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Never Miss a Service</h2>
          <p className="text-xl mb-8">
            Subscribe to our notifications and join the PAAM family to receive exclusive access to special broadcasts and archived content.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/join" 
              className="bg-white text-[#b8144a] hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Join PAAM Family
            </a>
            <a 
              href="/join" 
              className="border-2 border-white text-white hover:bg-white hover:text-[#b8144a] px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Join CFN for Notifications
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LiveStreamingPage;
